import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const userConfig = {
  saveTableConfig: async (
    user,
    tableFieldTemplateId,
    selectedSubArr,
    tableContext,
    activityType,
    tableConfigContext,
    totalField,
  ) => {
    const result = await axios.post(
      `${NODE_BASE_URL}/user/user-detail/save-user-table-configs`,
      {
        user_id: user.id,
        table_field_template_id: tableFieldTemplateId,
        subfield_ids: selectedSubArr,
        table_context: tableContext,
        activity_type: activityType,
        table_config_context: tableConfigContext,
        total_by_subfield_template_id: totalField,
      },
      getAxiosOptions(user),
    )
    return result.data
  },

  getTableConfig: async (user) => {
    return await axios.get(
      `${NODE_BASE_URL}/user/user-detail/get-user-table-configs/${user.id}`,
      getAxiosOptions(user),
    )
  },

  getHiddenRoutesConfig: async (user, processReferenceNum) => {
    return await axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/get-hidden-routes/${processReferenceNum}`,
      getAxiosOptions(user),
    )
  },

  getDynamicList: (user) => {
    return axios.get(
      `${NODE_BASE_URL}/user/user-detail/users-teams-dynamic-lists`,
      getAxiosOptions(user),
    )
  },

  getUserTeamMap: (user) => {
    return axios.get(
      `${NODE_BASE_URL}/user/user-detail/user-team-map/company`,
      getAxiosOptions(user),
    )
  },

  getUsersByCompany: (user) => {
    return axios.get(`${NODE_BASE_URL}/user/user-detail/company`, getAxiosOptions(user))
  },

  getDesignationsByCompany: (user) => {
    return axios.get(`${NODE_BASE_URL}/user/user-detail/designations`, getAxiosOptions(user))
  },

  getAllAllowedTeamsInProcess: async (user, processTemplateId, fieldTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/user/allowed-teams/${processTemplateId}/${fieldTemplateId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  updateAssignmentFieldTeamMap: async (user, fieldTemplateId, data) => {
    return await axios.post(
      `${NODE_BASE_URL}/admin/user/team-assignment-field-map/${fieldTemplateId}`,
      data,
      getAxiosOptions(user),
    )
  },
}
